import React from "react";
import { Button, Checkbox, FormControlLabel } from "@mui/material";
import "./tarifcardcss.js";
import MenuOptions from "../threeDots/Menu";
import Styles from "./tarifcardcss.js";
const TariffCard = (props) => {
  return (
    <Styles>
      <div className="status-card tariff_card">
        <div className="status-card__info">
          <h4>{props.name}</h4>
          <div className="menu-dots">
            {props.data ? (
              <MenuOptions
                options={[
                  {
                    value: "Изменять",
                    callback: () => props.edit(props.data),
                  },
                  {
                    value: "Удалить",
                    callback: () => props.delete(props.data.id),
                  },
                ]}
              />
            ) : null}
          </div>

          <div className="round">
            <h3>
              {props.keywords} <br />
              <p className="small m-0"> keys</p>
            </h3>
            <p></p>
          </div>
          {/*  */}
          {props.data && (
            <FormControlLabel
              onChange={(e) => props.activeHandler(props.data.id)}
              control={<Checkbox />}
              checked={props.data.active}
              label="Active"
              labelPlacement="start"
            />
          )}
          {props.bought ? (
            ""
          ) : props?.price > 0 ? (
            <p className="m-0">
              Цена: <b>{props.price.toLocaleString()}</b> сум
            </p>
          ) : (
            <p className="m-0">
              Цена: <b>Бесплатно</b>
            </p>
          )}
          {props.date && (
            <p>
              Длительность:<b> {props.date} </b>дней
            </p>
          )}
          {props.onClick ? (
            <Button
              variant="contained"
              style={{
                background: "var(--second-color)",
                padding: "12px 40px",
                borderRadius: "40px",
                fontWeight: "bold",
              }}
              onClick={props.onClick}
            >
              выбрать
            </Button>
          ) : null}
        </div>
      </div>
    </Styles>
  );
};
export default TariffCard;
